import {
  ADD_SHORT_CRITIC,
  CLEAR_CURRENT_RLATION,
  GET_SHORT_CRITIC,
  GET_SHORT_CRITIC_LIST,
  REMOVE_SHORT_CRITIC,
  UPDATE_SHORT_CRITIC,
} from '@jumbo/constants/ActionTypes';


const INIT_STATE = {
  shortCriticsList: [],
  shortCritic: {},
  currentShortCritic: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SHORT_CRITIC:
      return {
        ...state,
        currentShortCritic: action.payload,
      };

    case ADD_SHORT_CRITIC:
      return {
        ...state,
        shortCriticsList: state.shortCriticsList.concat(action.payload),
      };

    case UPDATE_SHORT_CRITIC:
      return {
        ...state,
        currentShortCritic: action.payload,
      };

    case GET_SHORT_CRITIC_LIST:
      return {
        ...state,
        shortCriticsList: action.payload.movie_critics,
      };

    case REMOVE_SHORT_CRITIC:
      return {
        ...state,
        shortCriticsList: state.shortCriticsList.filter(item => item.id !== action.payload),
      };

    case CLEAR_CURRENT_RLATION:
      return {
        ...state,
        currentShortCritic: null,
      };

    default:
      return state;
  }
};
